import { logger } from '../../../../utils/common/logger'
import { Store } from '../../../../utils/storage/keys'
import { LocalStore } from '../../../../utils/storage/local'
import { IProfile } from '../../../common/profile'
import { LoginService } from '../loginradius/services/login-service'
import SailthruAdapter from '../sailthru'

export class NewsletterOptIn {
    public static DOM = {
        attrs: {
            newsletterMaybeLater: 'data-newsletter-maybe-later',
            newsletterSignup: 'data-newsletter-sign-up'
        },
        class: {
            newsletterOptInError: 'newsletter-opt-in__error',
            newsletterOptInMain: 'newsletter-opt-in__main',
            newsletterOptInSuccess: 'newsletter-opt-in__success',
            pageNewsletterOptIn: 'page-newsletter-opt-in',
            pageOnboardNewsletterOptIn: 'page-onboard-newsletter-opt-in'
        }
    }

    public mainBanner: HTMLDivElement
    public successBanner: HTMLDivElement
    public errorBanner: HTMLDivElement

    public init() {
        const newsletterOptInPage = document.querySelector
            (`.${NewsletterOptIn.DOM.class.pageNewsletterOptIn}`)
        const onboardNewsletterOptInPage = document.querySelector
            (`.${NewsletterOptIn.DOM.class.pageOnboardNewsletterOptIn}`)

        if (newsletterOptInPage || onboardNewsletterOptInPage) {
            const profile = LocalStore.get<IProfile>(Store.ID)
            const newsletterSignupButton =
                document.querySelector(`[${NewsletterOptIn.DOM.attrs.newsletterSignup}]`) as HTMLButtonElement
            const newsletterMaybeLaterButtons =
                document.querySelectorAll(`[${NewsletterOptIn.DOM.attrs.newsletterMaybeLater}]`)
            const email = (profile && profile.email) ? profile.email : undefined
            const isSubscriber = profile && profile.adLight
            const redirect = LoginService.getRegistrationSuccessURL(location.origin)
            this.mainBanner = document.querySelector(`.${NewsletterOptIn.DOM.class.newsletterOptInMain}`)
            this.successBanner = document.querySelector(`.${NewsletterOptIn.DOM.class.newsletterOptInSuccess}`)
            this.errorBanner = document.querySelector(`.${NewsletterOptIn.DOM.class.newsletterOptInError}`)

            if (newsletterSignupButton) {
                newsletterSignupButton.addEventListener('click', async () => {
                    const newsletterList =
                        newsletterSignupButton.getAttribute(NewsletterOptIn.DOM.attrs.newsletterSignup)

                    if (!isSubscriber && onboardNewsletterOptInPage) {
                        logger('error', 'User is not subscribed.')
                        this.showErrorMessage()
                        return
                    }

                    try {
                        if (email) {
                            // Sailthru sign up
                            await SailthruAdapter.addToEmailList(email, newsletterList)
                            this.showSuccessMessage()
                        } else {
                            logger('error', 'User is not logged in')
                            this.showErrorMessage()
                        }
                    } catch(e) {
                        this.showErrorMessage()
                    }
                })
            }

            if (newsletterMaybeLaterButtons.length > 0) {
                newsletterMaybeLaterButtons.forEach(((newsletterMaybeLaterButton) => {
                    newsletterMaybeLaterButton.addEventListener('click', () => {
                        location.replace(redirect)
                    })
                }))
            }
        }
    }

    public showSuccessMessage() {
        if (this.mainBanner && this.successBanner) {
            this.mainBanner.setAttribute('hidden', 'hidden')
            this.successBanner.removeAttribute('hidden')
        }
    }

    public showErrorMessage() {
        if (this.mainBanner && this.errorBanner) {
            this.mainBanner.setAttribute('hidden', 'hidden')
            this.errorBanner.removeAttribute('hidden')
        }
    }
}
